import {BaseContainerModel} from '../../base-container.model';
import {bl_fi_my_einvoice_to_irb_export_file_hdr_RowClass} from '../../../dbschema';


export class EinvoiceToIrbExportFileContainerModel extends BaseContainerModel {
    bl_fi_my_einvoice_to_irb_export_file_hdr : bl_fi_my_einvoice_to_irb_export_file_hdr_RowClass = new bl_fi_my_einvoice_to_irb_export_file_hdr_RowClass();
}